import { useMutation } from '@apollo/client';
import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import invariant from 'tiny-invariant';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { PageHeading } from '~/components/common/PageHeading';
import { Button } from '~/components/ui/button';
import { HookFormErrors } from '~/components/ui/forms/HookFormErrors';
import { VomFormFields } from '~/components/upload/vom/vom-form-fields-v4';
import * as routes from '~/paths';
import { useZodForm } from '~/utils/forms';
import { initialVom } from '~/utils/modules/vom';
import { vomSchema } from '~/utils/modules/vom-v4';
import { UpdateVomNavigation } from './$vomId/__UpdateVomNavigation';

export const CREATE_VOM = graphql(`
  mutation CreateVom($input: VirtualOutcropModelCreateInput!) {
    virtualOutcropModelCreate(input: $input) {
      result {
        id
      }
    }
  }
`);

export default function CreateVomPage() {
  return (
    <ApolloProviderV4>
      <CreateVomPageInner />
    </ApolloProviderV4>
  );
}

function CreateVomPageInner() {
  const navigate = useNavigate();

  const [createVom, { loading, error }] = useMutation(CREATE_VOM);

  const form = useZodForm({
    schema: vomSchema,
    values: initialVom(),
  });

  const handleSubmit = form.handleSubmit(async values => {
    try {
      const res = await createVom({
        variables: {
          input: values,
        },
      });

      const vomId = res.data?.virtualOutcropModelCreate?.result?.id;
      invariant(vomId, 'Unknown error creating VOM');
      toast.success('VOM created successfully.');
      navigate(routes.uploadVomUpdateRoute(parseInt(vomId)));
    } catch (err) {
      toast.error('There was a problem creating the VOM.');
    }
  });

  return (
    <>
      <PageHeading>Create Virtual Outcrop Model</PageHeading>

      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-2">
          <UpdateVomNavigation vomId={-1} />
        </div>

        <div className="lg:col-span-10">
          <FormProvider {...form}>
            <form onSubmit={handleSubmit} className="space-y-4">
              <VomFormFields />
              <HookFormErrors graphQLError={error} />

              <div className="text-center">
                <Button type="submit" color="primary" loading={loading}>
                  Save
                </Button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </>
  );
}
